<div class="routing-container">
    <label>Distance</label>
    <span class="distance" *ngIf="distance">{{ distance | number:'1.2-2' }} {{ unit }}</span>
</div>
<div class="routing-container">
    <label for="style">Unit</label>
    <select id="style" name="style" [ngModel]="unit" (ngModelChange)="unitChange($event)">
        <option *ngFor="let option of units" [value]="option" [selected]="unit === option">{{ option }}</option>
    </select>
</div>
<fieldset class="radio-group">
    <input type="radio" name="clickBehavior" id="stop" class="radio-group-input" [(ngModel)]="AddingType" value="stop">
    <label for="stop" class="radio-group-label">Add Stop</label>
    <input type="radio" name="clickBehavior" id="barrier" class="radio-group-input" [(ngModel)]="AddingType"
        value="barrier">
    <label for="barrier" class="radio-group-label">Add Barrier</label>
</fieldset>
<div class="barriers-container list-container" *ngIf="routeParams?.pointBarriers">
    <div class="barrier list-item" *ngFor="let barrier of routeParams.pointBarriers.features; index as i"
        (mouseover)="overGraphic(barrier)" (mouseout)="outGraphic(barrier)">
        <img [src]="barrier.symbol.url" class="list-item-icon">
        <span class="list-item-text">
            Barrier {{ i + 1 }}
            ({{ barrier.geometry.latitude | number:'1.4-4' }}:{{ barrier.geometry.longitude | number:'1.4-4' }})
        </span>
        <span class="icon-ui-close pull-right" style="cursor: pointer;"
            (click)="removeGraphic(barrier, 'barrier')"></span>
    </div>
</div>
<div class="stops-container list-container" *ngIf="routeParams?.stops">
    <div cdkDropList (cdkDropListDropped)="drop($event)">
        <div class="stop list-item" *ngFor="let stop of routeParams.stops.features; index as i"
             (mouseover)="overGraphic(stop)" (mouseout)="outGraphic()" cdkDrag>
            <img src="assets/images/maneuvers/esriDMTStopOrigin.png" class="list-item-icon">
            <span class="list-item-text">
                Location {{ i + 1 }}
                ({{ stop.geometry.latitude | number:'1.4-4' }}:{{ stop.geometry.longitude | number:'1.4-4' }})
            </span>
            <span class="icon-ui-close pull-right" style="cursor: pointer;"
                  (click)="removeGraphic(stop, 'stop')"></span>
        </div>
    </div>
</div>
<div class="maneuvers-container list-container" *ngIf="directions" [hidden]="hideDirections">
    <div class="maneuver list-item-direction" *ngFor="let direction of directions?.features" (click)="zoomToLocation(direction)">
        <div class="list-item-instruction">
            <img class="list-item-icon" src="assets/images/maneuvers/{{direction.attributes.maneuverType}}.png">
            <span class="list-item-text">{{ direction.attributes.text }}</span>
        </div>
        <div class="list-item-milage" *ngIf="direction.attributes.length > 0">
            <span class="list-item-milage-text">{{ direction.attributes.length | number:'1.2-2' }} {{ unit }} </span>
            <hr class="list-item-milage-spacer" />
        </div>
    </div>
</div>
<div class="routing-footer">
    <button class="btn btn-clear" [disabled]="!distance" [hidden]="hideCreateLayerButton" (click)=createLayer()>Create
        Layer</button>
    <button class="btn btn-clear" [disabled]="!routingLayer || (routingLayer.graphics.length === 0)"
        [hidden]="hideStartOverButton" (click)="startOver()">
        Start
        Over
    </button>
</div>
